import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { TeacherRecentStudent } from "@/hooks/useTeacherRecentStudents";

interface TeacherStudentsTableProps {
  data: TeacherRecentStudent[];
}

export const TeacherStudentsTable: React.FC<TeacherStudentsTableProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        ไม่พบข้อมูลในช่วงเวลาที่เลือก
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[200px]">ครู</TableHead>
            <TableHead className="w-[250px]">นักเรียน</TableHead>
            <TableHead className="text-center w-[100px]">จำนวนคลาส</TableHead>
            <TableHead className="text-center w-[100px]">รวมชั่วโมง</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={`${row.teacher_id}-${row.student_id}-${index}`}>
              <TableCell>
                <div className="font-medium">{row.teacher_id}</div>
                <div className="text-sm text-muted-foreground">
                  {row.nickname || row.full_name || '-'}
                </div>
              </TableCell>
              <TableCell>
                <div className="font-medium">
                  {row.student_nickname || '-'}
                </div>
                <div className="text-sm text-muted-foreground">
                  {[row.student_first_name, row.student_last_name].filter(Boolean).join(' ') || row.student_id}
                </div>
              </TableCell>
              <TableCell className="text-center font-medium">
                {row.total_class}
              </TableCell>
              <TableCell className="text-center font-medium">
                {row.total_hours}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
